import { render, staticRenderFns } from "./GalleryList.vue?vue&type=template&id=854eee8a&scoped=true"
import script from "./GalleryList.vue?vue&type=script&lang=js"
export * from "./GalleryList.vue?vue&type=script&lang=js"
import style0 from "./GalleryList.vue?vue&type=style&index=0&id=854eee8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854eee8a",
  null
  
)

export default component.exports